export default "__VITE_ASSET__BAg5Bzti__"